module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiMzMzMzMzMiIGQ9Ik02NDEuMjggMjc4LjYxMzMzM2wtNDUuMjI2NjY3LTQ1LjIyNjY2Ni0yNzguNjM0NjY2IDI3OC43NjI2NjYgMjc4LjYxMzMzMyAyNzguNDg1MzM0IDQ1LjI0OC00NS4yNjkzMzQtMjMzLjM2NTMzMy0yMzMuMjM3MzMzeiIgLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/arrow-left.svg
// module id = 9B/N
// module chunks = 0 1 2 3 4 5 6 7 8